import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  popper: {
    [theme.breakpoints.down(1025)]: {
      width: '350px',
      top: '40px !important',
      left: '15px !important',
    },
    [theme.breakpoints.down(376)]: {
      width: '350px',
      top: '40px !important',
      left: '2px !important',
    },
  },
}))

export default useStyles
